module.exports = {
  host: process.env.HOST || 'localhost',
  open: true,
  port: process.env.PORT || 8081,
  apiRoot: process.env.VUE_APP_API_ROOT || 'http://localhost:8001',
  project: {
    // from base-touchscreen branch (e.g.: T-Place and ReMap)
    titleLogo: true,
    logoSize: 'wide', // 'normal'
    subtitle: '',
    menuSubtitle: '',
    footerTitle: 'Dionysos',
    footerText: `<div class="grid grid-cols-2 w-full md:w-4/5 lg:w-3/4 xl:w-1/2 m-auto gap-10 py-10">
      <div class="col-span-1 footer-1 text-xs/6">
        <div class="text-left">Dionysos<br/>
      </div>
      <div class="grid grid-cols-2 py-6">
        <!--<div>
          
        </div>
        <div class="text-left text-xs/5">
          eISBN 979-12-215-0591-7<br/>
          ISBN 979-12-215-0592-4 (XML)<br/>
          DOI 10.36253/979-12-215-0591-7
        </div>
          
        </div>-->
      </div>
      <div class="col-span-1 footer-2 text-left text-xs/6">
        Content license: CC BY-SA 4.0 International<br/>
        Metadata license: CC0 1.0 Universal<br/>
        <!--Published by Firenze University Press<br/>-->
        Realizzazione Web a cura di:<br/>
        LiEC - Laboratorio interdisciplinare sulle Eredità Culturali<br/>
        Dipartimento SAGAS, Università degli Studi di Firenze
      </div>
    </div>`,
    copyright: 'LiEC @ 2026',
    subtitleSize: 'sm',
    font:
    {
      title: "font-titillium",
      body: "font-titillium"
    },
    style:
    {
      background: "bg-white",
      homeText: "text-white",
      text: "text-black",
      color: "#000"
    },
    bars: {
      top: { position: 'top', cols: 8, logoSize: 4, logoLink: '/', logoAlt: 'Logo Top', menuSize: 4, hideOnMobile: true},
      main: { position: 'main', cols: 8, logoSize: 2, logoLink: '/', logoAlt: process.env.VUE_APP_NAME, menuSize: 6}
    },
  },
  search: {
    models: [ 
      { value: "cards", label: "Schede" },
      { value: "persons", label: "Artisti" },
      { value: "card_containers", label: "Mostre" },
      { value: "posts", label: "Articoli" },
      { value: "scan_cards", extends: "cards", label: "Campi scheda SCAN" }
    ],
    fields: [
      { field: "tags", type: "select-api", label: "Tags", vocabulary: "tags" }
    ]
  },
  templates: {
    persons: ["tags", "map", "qualifications", "gallery", "start_fields", "related_entities", "end_fields", "references"],
    scan_cards: ["tags", "map", "gallery", "persons", "card_containers", "cardable_start_fields", "related_entities", "cardable_end_fields", "relateds", "references", "attachments"],
    f_cards: ["tags", "gallery", "collection", "persons", "map", "card_containers", "cardable_start_fields", "related_entities", "cardable_end_fields", "references", "relateds"],
    itinerary: ["description", "map", "timeline_vertical"],
        "landscape-itinerary": ["description", "timeline_horizontal"],
        "temporary-exhibition": ["description", "cards"],
    exhibition: ["description", "cards"],
        "art-collection": ["description", "cards"],
    glossary: ["description", "cards"],
    collections: ["tags", "description", "gallery", "f_cards"],
    references: ["tags", "fields", "cards", "persons"]
  },
  models: {
    scan_cards: {
        extended: true,
        single: "Scheda SCAN",
        plural: "Schede SCAN",
        visibility: "all",
        fields: [
            { field: "esc", type: "text", label: "Ente schedatore (ESC)", position: "start", visibility: "all" },
            { field: "ogt", type: "text", label: "Tipologia/altre specifiche (OGT)", position: "start", visibility: "all" },
            { field: "ogn", type: "repeating", label: "Denominazione/titolo (OGN)", position: "start", visibility: "all" },
            { field: "lcs", type: "text", label: "Stato (LCS)", position: "start", visibility: "all" },
            { field: "lcr", type: "select-api", vocabulary: "regions", label: "Regione (LCR)", position: "start", visibility: "all" },
            { field: "lcp", type: "select-api", vocabulary: "provinces", label: "Provincia (LCP)", position: "start", visibility: "all" },
            { field: "lcc", type: "text", label: "Comune (LCC)", position: "start", visibility: "all" },
            { field: "lci", type: "text", label: "Indirizzo (LCI)", position: "start", visibility: "all" },
            { field: "lcv", type: "text", label: "Altri percorsi/specifiche (LCV)", position: "start", visibility: "all" },
            { field: "plv", type: "repeating", label: "Toponimo / Località (PLV)", position: "start", visibility: "all" },
            { field: "pvz", type: "text", label: "Tipo di contesto (PVZ)", position: "start", visibility: "all" },
            { field: "ldcn", type: "text", label: "Denominazione contenitore fisico (LDCN)", position: "start", visibility: "all" },
            { field: "ldcs", type: "text", label: "Specifiche di collocazione (LDCS)", position: "start", visibility: "all" },
            { field: "dtzg", type: "text", label: "Fascia cronologica/periodo (DTZG)", position: "start", visibility: "all" },
            { field: "dtzs", type: "text", label: "Specifiche (DTZS)", position: "start", visibility: "all" },
            { field: "dtsi", type: "text", label: "Da (DTSI)", position: "start", visibility: "all" },
            { field: "dtsv", type: "text", label: "Validità Da (DTSV)", position: "start", visibility: "all" },
            { field: "dtsf", type: "text", label: "A (DTSF)", position: "start", visibility: "all" },
            { field: "dtt", type: "text", label: "Note (DTT)", position: "start", visibility: "all" },
            { field: "des", type: "text", label: "Descrizione del bene (DES)", position: "start", visibility: "all" },
            { field: "aid", type: "text", label: "Apparato iconografico/decorativo (AID)", position: "start", visibility: "all" },
            { field: "res", type: "text", label: "Dati provenienza archeologica (RES)", position: "start", visibility: "all" },
            { field: "nsc", type: "text", label: "Approndimenti storico-critici (NSC)", position: "start", visibility: "all" },
            { field: "bib", type: "repeating", label: "Bibliografia (BIB)", position: "end", visibility: "all" },
            { field: "cam", type: "text", label: "Caratteri ambientali beni immobili (CAM)", position: "start", visibility: "profile" },
            { field: "ro", type: "repeating", label: "Risorse Online", position: "start", visibility: "profile" }
        ],
        related: ["scan_documentations", "scan_historicals", "scan_certifications", "scan_measures", "scan_authorities"],
        pivot:
        {
            locations: [
                { field: "type", type: "text", label: "Tipo di luogo", position: "start", visibility: "all" },
                { field: "location_person_type_id", type: "text", label: "Tipo di luogo", position: "start", visibility: "all" },
                { field: "description", type: "text", label: "Descrizione", position: "start", visibility: "all" }
            ],
            cards: [
                { field: "card_person_type_id", type: "text", label: "Tipo di scheda", position: "start", visibility: "all" },
                { field: "description", type: "text", label: "Descrizione", position: "start", visibility: "all" }
            ]
        },
        reference_format: [
            { field: "citation", format: "normal", separator: ": " },
            { field: "author", format: "normal", separator: ", " },
            { field: "title", format: "normal", separator: ", " },
            { field: "place", format: "normal", separator: ", " },
            { field: "year", format: "normal", separator: ""}
        ]
    },
    persons: {
        single: "Persona",
        plural: "Persone",
        visibility: "all",
        color: "blue",
        fields: [
            { field: "name", type: "text", label: "Nome scelto", position: "start", visibility: "all" },
            { field: "pre_name", type: "text", label: "Prenome", position: "start", visibility: "all" },
            { field: "first_name", type: "repeating", label: "Primo nome", position: "start", visibility: "all" },
            { field: "middle_name", type: "text", label: "Secondo nome", position: "start", visibility: "all" },
            { field: "last_name", type: "repeating", label: "Cognome", position: "start", visibility: "all" },
            { field: "title", type: "text", label: "Titolo", position: "start", visibility: "all" },
            { field: "nick_name", type: "repeating", label: "Soprannome", position: "start", visibility: "all" },
            { field: "initials", type: "text", label: "Iniziali", position: "start", visibility: "profile" },
            { field: "sex", type: "text", label: "Sesso", position: "start", visibility: "all" },
            { field: "birth_date", type: "date", label: "Data di nascita", position: "start", visibility: "all" },
            { field: "birth_place", type: "text", label: "Luogo di nascita", position: "start", visibility: "all" },
            { field: "death_date", type: "date", label: "Data del decesso", position: "start", visibility: "all" },
            { field: "death_place", type: "text", label: "Luogo del decesso", position: "start", visibility: "all" },
            { field: "from_date", type: "text", label: "Data nascita testuale", position: "start", visibility: "all" },
            { field: "to_date", type: "text", label: "Data del decesso estuale", position: "start", visibility: "all" },
            { field: "notes", type: "text", label: "Note", position: "start", visibility: "profile" },
            { field: "origin", type: "text", label: "Origine", position: "start", visibility: "profile" },
            { field: "nationality", type: "text", label: "Nazionalità", position: "start", visibility: "all" },
            { field: "website", type: "text", label: "Link sito web", position: "start", visibility: "all" },
            { field: "biography", type: "text", label: "Biografia", position: "end", visibility: "all" },
            { field: "notes", type: "text", label: "Note", position: "end", visibility: "all" }
        ],
        related: ["cards", "person_certifications", "person_types"],
        pivot:
        {
            locations: [
                { field: "location_person_type_id", type: "text", label: "Tipo di luogo", position: "start", visibility: "all" },
                { field: "description", type: "text", label: "Descrizione", position: "start", visibility: "all" }
            ],
            cards: [
                { field: "card_person_type_id", type: "text", label: "Tipo di scheda", position: "start", visibility: "all" },
                { field: "description", type: "text", label: "Descrizione", position: "start", visibility: "all" }
            ]
        },
        reference_format: [
            { field: "citation", format: "normal", separator: ": " },
            { field: "author", format: "normal", separator: ", " },
            { field: "title", format: "normal", separator: ", " },
            { field: "place", format: "normal", separator: ", " },
            { field: "year", format: "normal", separator: "" }
        ]
    },
    card_containers: {
        single: "Contenitore Schede",
        plural: "Contenitori Schede",
        visibility: "all",
        color: "yellow",
        fields: [
            { field: "name", type: "text", label: "Nome" },
            { field: "description", type: "text", label: "Descrizione" },
            { field: "code", type: "text", label: "Codice" },
            { field: "card_container_type_id", type: "text", label: "Tipologia", position: "start", visibility: "all" }
        ],
        pivot: {
            cards: [
                { field: "start_date", type: "date", label: "Data inizio", position: "start", visibility: "all" },
                { field: "end_date", type: "date", label: "Data fine", position: "start", visibility: "all" },
                { field: "description", type: "text", label: "Descrizione", position: "start", visibility: "all" }
            ]
        }
    },
    references: {
        single: "Riferimento bibliografico",
        plural: "Riferimenti bibliografici",
        visibility: "all",
        color: "purple",
        fields: [
            { field: "title", type: "text", label: "Titolo", position: "start", separator: ", " },
            { field: "author", type: "text", label: "Autore", position: "start", visibility: "all", separator: ", " },
            { field: "year", type: "text", label: "Anno", position: "start", visibility: "all", separator: " " },
            { field: "place", type: "text", label: "Luogo", format: "normal", separator: "" }
        ],
        pivot: {
            cards: [{ field: "citation", type: "text", label: "Citazione", position: "start", visibility: "all" }]
        }
    },
    cards: {
        single: "Scheda",
        plural: "Schede",
        visibility: "all",
        color: "green",
        fields: [
            { field: "name", type: "text", label: "Nome" },
            { field: "description", type: "text", label: "Descrizione" },
            { field: "code", type: "text", label: "Codice" },
            { field: "regione", type: "select-api", label: "Regione", vocabulary: "regions" },
            { field: "provincia", type: "select-api", label: "Provincia", vocabulary: "provinces" }
        ],
        pivot: {
            persons: [
                { field: "card_person_type_id", type: "text", label: "Tipo di scheda", position: "start", visibility: "all" },
                { field: "description", type: "text", label: "Descrizione", position: "start", visibility: "all" }
            ],
            cards: [
                { field: "description", type: "text", label: "Note sulle relazioni (REZ)", position: "start", visibility: "all" },
                { field: "direction", type: "text", label: "Specifiche tipo relazione (RSES)", position: "start", visibility: "all" },
                { field: "type", type: "vocabulary", label: "Tipo di relazione (RSER)", position: "start", visibility: "all" },
                { field: "notes", type: "text", label: "Altre note", position: "start", visibility: "all" }
            ]
        }
    },
    scan_documentations: {
        single: "Documentazione (DO)",
        plural: "Documentazione (DO)",
        visibility: "all",
        fields: [
            { field: "dcmn", type: "text", label: "Codice identificativo (DCMN)", position: "start", visibility: "all" },
            { field: "dcmp", type: "text", label: "Tipo (DCMP)", position: "start", visibility: "all" },
            { field: "dcmm", type: "text", label: "Titolo/didascalia (DCMM)", position: "start", visibility: "all" },
            { field: "dcma", type: "text", label: "Autore (DCMA)", position: "start", visibility: "all" },
            { field: "dcmr", type: "text", label: "Riferimento cronologico (DCMR)", position: "start", visibility: "all" },
            { field: "dcme", type: "text", label: "Ente proprietario (DCME)", position: "start", visibility: "all" },
            { field: "dcmc", type: "text", label: "Collocazione (DCMC)", position: "start", visibility: "all" },
            { field: "dcmw", type: "text", label: "Indirizzo web (DCMW)", position: "start", visibility: "all" },
            { field: "dcmk", type: "text", label: "Nome file (DCMK)", position: "start", visibility: "all" },
            { field: "dcmt", type: "text", label: "Note (DCMT)", position: "start", visibility: "all" }
        ],
        related: ["scan_cards"]
    },
    scan_historicals: {
        single: "",
        plural: "Fonti e documenti",
        visibility: "profile",
        fields: [
            { field: "dtns", type: "text", label: "Notizia di sintesi (DTNS)", position: "start", visibility: "all" },
            { field: "dtr", type: "text", label: "Riferimento cronologico (DTR)", position: "start", visibility: "all" },
            { field: "dtg", type: "text", label: "Specifiche riferimento cronologico (DTG)", position: "start", visibility: "all" },
            { field: "dtnn", type: "text", label: "Notizia di dettaglio (DTNN)", position: "start", visibility: "all" }
        ],
        related: ["scan_cards"]
    },
    scan_certifications: {
        single: "Voce di certificazione / gestione dati (CM)",
        plural: "Voci di certificazione / gestione dati (CM)",
        visibility: "all",
        fields: [
            { field: "cmr", type: "text", label: "Responsabile (CMR)", position: "start", visibility: "all" },
            { field: "cma", type: "text", label: "Anno di redazione (CMA)", position: "start", visibility: "all" },
            { field: "adp", type: "text", label: "Profilo di pubblicazione (ADP)", position: "start", visibility: "all" },
            { field: "oss", type: "text", label: "Note (OSS)", position: "start", visibility: "all" }
        ],
        related: ["scan_cards"]
    },
    scan_authorities: {
        single: "Autore responsabilità (AUT)",
        plural: "Autori responsabilità (AUT)",
        visibility: "all",
        fields: [
            { field: "autn", type: "text", label: "Nome di persona o Ente (AUTN)", position: "start", visibility: "all" },
            { field: "auta", type: "text", label: "Indicazioni cronologiche (AUTA)", position: "start", visibility: "all" },
            { field: "autz", type: "text", label: "Note (AUTZ)", position: "start", visibility: "all" },
            { field: "autj", type: "text", label: "Ente schedatore (AUTJ)", position: "start", visibility: "all" },
            { field: "auth", type: "text", label: "Codice identificativo (AUTH)", position: "start", visibility: "all" }
        ],
        related: ["scan_cards"]
    },
    scan_measures: {
        single: "Misura (MIS)",
        plural: "Misure (MIS)",
        visibility: "all",
        fields: [
            { field: "misz", type: "text", label: "Tipo misura (MISZ)", position: "start", visibility: "all" },
            { field: "misu", type: "text", label: "Unità di misura (MISU)", position: "start", visibility: "all" },
            { field: "mism", type: "text", label: "Valore (MISM)", position: "start", visibility: "all" },
            { field: "misv", type: "text", label: "Note (MISV)", position: "start", visibility: "all" }
        ],
        related: ["scan_cards"]
    },
    pages: {
        single: "Pagina",
        plural: "Pagine",
        visibility: "all",
        color: "red",
        fields: [{ field: "title", type: "text", label: "Titolo", position: "start", visibility: "all" }]
    },
    posts: {
        single: "Articolo",
        plural: "Articoli",
        visibility: "all",
        color: "green",
        fields: [ { field: "title", type: "text", label: "Titolo", position: "start", visibility: "all" } ]
    },
    qualifications: {
        single: "",
        plural: "Qualifiche",
        visibility: "all",
        color: "violet",
        fields: [
            { field: "name", type: "text", label: "Nome", position: "start", visibility: "all" }
        ]
    },
    person_certifications: {
        single: "Voce di certificazione / gestione dati (CM)",
        plural: "Voci di certificazione / gestione dati (CM)",
        visibility: "all",
        fields: [
            { field: "name", type: "text", label: "Responsabile (CMR)", position: "start", visibility: "all" },
            { field: "year", type: "text", label: "Anno di redazione (CMA)", position: "start", visibility: "all" },
            { field: "note", type: "text", label: "Note (OSS)", position: "start", visibility: "all" }
        ],
        related: ["persons"]
    },
    person_types: {
        single: "Tipo di persona",
        plural: "Tipi di persona",
        visibility: "all",
        fields: [
            { field: "name", type: "text", label: "Nome", position: "start", visibility: "all" },
            { field: "description", type: "text", label: "Descrizione", position: "start", visibility: "all" }
        ],
        related: ["persons"]
    }
  }
}